import React from 'react';
import { Link } from 'react-router-dom';
import useSeoForPage from '../hooks/useSeoForPage';

function Section({ title, children }) {
  return (
    <section className="mb-10">
      <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
        {title}
      </h2>
      <div className="space-y-4 text-slate-600 leading-relaxed text-[15px]">{children}</div>
    </section>
  );
}

export default function AboutPage() {
  useSeoForPage('/ueber-uns');
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="text-3xl font-semibold text-slate-900 mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
        Über uns
      </h1>

      <Section title="Warum gibt es Domain-Preisvergleich.de?">
        <p>
          Ein Sternchen hier, ein wenig Kleingedrucktes da. Das erste Jahr günstig, alle weiteren deutlich teurer –
          das ist leider die Realität bei vielen Registraren. Einen schnellen Überblick zu bekommen, wo eine bestimmte
          Domain langfristig am günstigsten ist, ist daher leider sehr schwierig. Schade, denn bei Domains gibt es
          riesige Preisunterschiede – obwohl es sich um ein rein digitales Produkt handelt, bei dem es keine
          Qualitätsunterschiede gibt. Also haben wir uns hingesetzt und diese Seite gebaut.
        </p>
        <p>
          Der Domainmarkt ist voll von Sternchen, Kleingedrucktem und Lockangeboten. Um herauszufinden, wo eine
          Domain langfristig am günstigsten ist, musste man bisher Stunden investieren. Wir sind angetreten, diesen
          Zustand zu ändern und einen übersichtlichen Vergleich für möglichst alle Domainendungen zur Verfügung zu
          stellen.
        </p>
      </Section>

      <Section title="Wo kommen die Preisdaten her?">
        <p>
          Unsere Preise werden automatisch und regelmäßig von den öffentlichen Preislisten der Anbieter erfasst,
          validiert und aktualisiert. Zusätzlich können Anbieter ihre Preise direkt bei uns pflegen – so bleiben die
          Angaben so aktuell und korrekt wie möglich.
        </p>
        <p>
          Langfristig ist unser Ziel, dass sich die Registrare dazu bereit erklären, uns ihre Preise elektronisch zu
          übermitteln. Bis dahin halten wir die Datenbank durch regelmäßige automatische Prüfungen aktuell.
        </p>
      </Section>

      <Section title="Wie viel kann man wirklich sparen?">
        <p>
          Das hängt natürlich vom individuellen Domain-Portfolio ab. Generell lässt sich aber häufig sehr viel Geld
          sparen: Wer zum Beispiel zwei .de-Domains für fünf Jahre registriert, kann je nach Anbieter mehrere Dutzend
          Euro Unterschied ausmachen – ganz ohne Qualitätsunterschied, denn die Domain selbst ist überall dieselbe.
        </p>
        <p>
          Gerade bei internationalen Portfolios (z. B. je eine .de, .fr, .it, .dk, .es, .pl, .at und .ch-Domain über
          zehn Jahre) summieren sich die Preisunterschiede zwischen den Anbietern schnell auf mehrere Hundert Euro.
        </p>
      </Section>

      <Section title="Unsere Vergleichsmethode">
        <p>
          Viele Anbieter haben im ersten Jahr einen günstigeren Preis als in den Folgejahren (Lockangebot). Um direkt
          den bestmöglichen Vergleich zu liefern, zeigen wir in der Tabelle den durchschnittlichen Jahrespreis für
          eine Laufzeit von fünf Jahren. Der Preis-Leistungs-Sieger ist der günstigste Anbieter mit einer
          durchschnittlichen Kundenbewertung von mehr als vier Sternen – als Bewertungsquellen nutzen wir unter
          anderem Trusted Shops, Trustpilot und eKomi.
        </p>
      </Section>

      <p className="text-sm text-slate-400">
        Mehr dazu in unserem{' '}
        <Link to="/ratgeber" className="text-sky-600 hover:text-sky-700">Domain-Kauf-Ratgeber</Link>.
      </p>
    </div>
  );
}
